import { createElement, type PropsWithChildren, type ReactNode } from 'react';
import type { TextProps } from '@react-pdf/renderer';

export async function loadOemPdfRenderer() {
  const renderer = await import('@react-pdf/renderer');
  const { Font } = renderer;
  Font.register({
    family: 'Noto Sans Thai',
    fonts: [
      { src: `${location.origin}/fonts/NotoSansThai-Regular.ttf`, fontWeight: 400 },
      { src: `${location.origin}/fonts/NotoSansThai-Bold.ttf`, fontWeight: 700 },
    ],
  });
  const pdfText = (value: ReactNode): ReactNode => {
    if (typeof value === 'string') return value.replace(/\u0e33/g, '\u0e4d\u0e32');
    if (Array.isArray(value)) return value.map((child: ReactNode) => pdfText(child));
    return value;
  };
  const Text = ({ children, render, ...props }: PropsWithChildren<TextProps>) => {
    const dynamic: Pick<TextProps, 'render'> = render
      ? { render: (context) => pdfText(render(context)) }
      : {};
    return createElement(renderer.Text, { ...props, ...dynamic }, pdfText(children));
  };
  return Object.assign({}, renderer, { Text });
}
